import React, { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";

/**
 * Affiche les children si l’utilisateur est connecté Auth0,
 * sinon déclenche une redirection automatique vers le formulaire
 * d’authentification.
 */
export default function ProtectedRoute({ children }) {
    const { isAuthenticated, isLoading, loginWithRedirect } = useAuth0();

    /* redirection automatique quand on détecte qu’on n’est pas connecté */
    useEffect(() => {
        if (!isLoading && !isAuthenticated) {
            loginWithRedirect();
        }
    }, [isLoading, isAuthenticated, loginWithRedirect]);

    /* 1) pendant Auth0 loading → rien à l’écran
       2) si non-auth après redirection déclenchée → rien non plus
       3) si auth → on laisse passer les children */
    if (isLoading || !isAuthenticated) return null;
    return children ?? <Navigate to="/" replace />;
}
